import React, { useEffect, useRef } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, logout } from "../loginSlice";
import "./login.css";
import { setBackButtonUrl } from "../uiSlice";
import { selectAdminToken } from "../../admin/sessionSlice";
import { apiUrl } from "../../utils/apiUrl";
import Swal from "sweetalert2";

function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector((state) => state.auth);
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );

  const adminToken = useSelector(selectAdminToken);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAdmin = searchParams.get("admin") === "true";
  const isFromMobileApp = searchParams.get("fromMobileApp") === "true";
  const mobileAppQuery = isFromMobileApp ? "?fromMobileApp=true" : "";
  const alreadyPlayedHandledRef = useRef(false);

  useEffect(() => {
    const otp = searchParams.get("otp");
    const demo = searchParams.get("demo");
    // Avoid stale hydrated user triggering "already played" before OTP/demo login finishes
    if (otp || demo) {
      dispatch(logout());
    }
    dispatch(loginUser());
  }, [dispatch, searchParams]);

  useEffect(() => {
    if (status === "succeeded" && user && isAdmin) {
      navigate("/admin");
    }
  }, [status, user, isAdmin, navigate]);

  useEffect(() => {
    console.log("user",user);
    if (status === "succeeded" && user.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }

  }, [status, user]);



 useEffect(() => {
  if (status !== "failed") return;
  const msg = error ? String(error) : "Session expired";
  const redirect = user && user.backButtonRedirect ? user.backButtonRedirect : "/";
  Swal.fire("Session Expired!", msg, "error").then(() => {
    window.location.href = redirect;
  });
}, [status, error, user]);

  // "Already played" only when the full slide run is finished (spotGameStatus.completed).
  // Do not use userPlayedCount alone — partial progress must allow resume.
  useEffect(() => {
    if (isAdmin) return;
    if (status !== "succeeded" || !user) return;
    if (alreadyPlayedHandledRef.current) return;

    const redirect =
      user.backButtonRedirect || process.env.REACT_APP_BASE_URL || "/";

    const showOnceAndRedirect = async () => {
      if (alreadyPlayedHandledRef.current) return;
      alreadyPlayedHandledRef.current = true;
      await Swal.fire({
        title: "You have already played!",
        icon: "error",
        timer: 3000,
        timerProgressBar: true,
        allowOutsideClick: false,
        showConfirmButton: true,
        confirmButtonText: "OK",
      });
      if (isFromMobileApp) {
        window.GameStatus?.postMessage?.("navigate_back");
      } else {
        window.location.href = redirect;
      }
    };

    if (!adminToken) return;

    let cancelled = false;
    (async () => {
      try {
        const resp = await fetch(apiUrl("/spotGameStatus"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminToken}`,
          },
          body: JSON.stringify({
            userId: user.userId,
            sessionId: user.sessionId,
            organizationId: user.organizationId,
          }),
        });
        const data = await resp.json();
        if (cancelled || alreadyPlayedHandledRef.current) return;
        if (data.success && data.completed) {
          await showOnceAndRedirect();
        }
      } catch (e) {
        console.error("spotGameStatus check on login:", e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [status, user, adminToken, isAdmin]);

  if (status === "loading" || themeStatus === "loading") {
    return (
      <div className="login-main-container">
        <div className="quiz-loader-container">
          <div className="quiz-loader"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-main-container">
      {themeData && (
        <img
          src={process.env.REACT_APP_S3_PATH + themeData.logo}
          className="login-logo"
          alt="Game Logo"
        />
      )}
        {user && status === "succeeded" && (
          <div>
            <Link
              to={`/game${mobileAppQuery}`}
              className="begin-play-btn"
              style={{
                ...(themeData?.button_backgroundcolor && { backgroundColor: themeData.button_backgroundcolor }),
                ...(themeData?.button_color && { color: themeData.button_color }),
              }}
            >
              BEGIN PLAY
            </Link>
          </div>
        )}
    </div>
  );
}

export default Login;
